export const attachmentTypes = {
  image: 'image',
  document: 'document'
};
